import app from './app';
import { SURVEYS_SERVICE_URL } from '../../libs/constants';
import { saveAs } from 'file-saver';
//POST 
const getSurveys = (userId, requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        const response = await api.post(SURVEYS_SERVICE_URL + 'survey/list/' + userId , {...requestData, source:"hw"});//change to post and end point
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_SURVEYS_DATA",
            data: response.data.surveyList
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};


//GET
const getSurveyDetails = (surveyId) => async (dispatch, getState, api) => {
    try {
        const config = {
            headers: {
                'Authorization': 'Bearer guestSurvey'
            }
        }
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        const response = await api.get(SURVEYS_SERVICE_URL + 'survey/' + surveyId, config);//change to get and end point
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_SURVEY_DETAILS",
            data: response.data
        });
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

//POST
const saveSurveyResponse = (requestData, callBack) => async (dispatch, getState, api) => {
    try {
        const config = {
            headers: {
                'Authorization': 'Bearer guestSurvey'
            }
        }
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        const response = await api.post(SURVEYS_SERVICE_URL + 'surveyResponse', requestData, config);//change to post and end point
        dispatch(app.setLoading(false));
        !!response && callBack();
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};


//POST
const saveSurveys = (userId, requestData, callBack) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        const response = await api.post(SURVEYS_SERVICE_URL + 'survey/create/' + userId, {...requestData, source:"hw"});//change to post and end point
        dispatch(app.setLoading(false));
        !!response && callBack();
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};
//PUT
const updateSavedSurveys = (surveyId, requestData, callBack, userId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        //const response = await api.put(SURVEYS_SERVICE_URL + 'survey/'+ surveyId,requestData);//change to put and end point
        const response = await api.post(SURVEYS_SERVICE_URL + 'survey/' + userId + '/' + surveyId, {...requestData, source:"hw"});//change to support Akamai
        dispatch(app.setLoading(false));
        callBack();
    } catch (error) {
        dispatch(app.setLoading(false));
        console.log(error);
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

//post
const deleteSurvey = (surveyId, callBack, userId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(SURVEYS_SERVICE_URL + 'survey/delete/' + userId + '/' + surveyId,{source:"hw"})
        .then(response => {
            dispatch(app.setLoading(false));
            callBack();
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//post
const generateReport = (surveyId, userId) => async (dispatch, getState, api) => {
    let downloadConfig = {
        headers: {
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        },
        responseType: "blob"
    };
    dispatch(app.setLoading(true));

    await api.post(SURVEYS_SERVICE_URL + 'surveyResponse/report/' + userId + '/' +surveyId, {source:"hw"}, downloadConfig)
        .then(response => {
            saveAs(new Blob([response.data]), "Responses.xlsx");
            dispatch(app.setLoading(false));
        })
        .catch((error) => {
            dispatch(app.setLoading(false));
            error && error.response &&  error.response.status === 404 &&  dispatch(app.setAppModal({ type: "error", messageId: "survey_empty_report" }));
        });
};

const setHasResponded = (data) => {
    return {
        type: "SET_HAS_SURVEYS_RESPONDED",
        data: data
    };
}


export default {
    getSurveys, saveSurveys, updateSavedSurveys, deleteSurvey, generateReport, getSurveyDetails, saveSurveyResponse
}